// package imports
import React, { useState } from 'react';

// CSS imports
import './NewsletterUserCard.css';

// Component imports
import DeleteButton from '../buttons/deleteButton/DeleteButton';
import Spinner from '../spinner/Spinner';

// Type imports
import { NewsletterUser } from '../../types/newsletter/NewsletterUser';

type Props = {
  className?: string;
  user: NewsletterUser;
  index: number;
  deleteUser: (id: string, x: number) => Promise<void>;
};

const NewsletterUserCard: React.FC<Props> = ({
  className,
  user,
  index,
  deleteUser,
}: Props) => {
  const [isLoading, setIsLoading] = useState(false);

  const triggerDeleteEmail = async () => {
    setIsLoading(true);
    await deleteUser(user.id, index);
    setIsLoading(false);
  };

  return (
    <div className={`NewsletterUserCard ${className ? className : ''}`}>
      <div className='side-container'>
        <span>{user.email}</span>
      </div>
      <div className='side-container'>
        <DeleteButton onClick={triggerDeleteEmail} />
      </div>
      {isLoading ? (
        <div className='loader-overlay'>
          <Spinner isLoading={true} />
        </div>
      ) : null}
    </div>
  );
};

export default NewsletterUserCard;
